import { Component, inject, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormField, form } from '@angular/forms/signals';
import { ETipoTransaccion } from '@core/enums/tipoTransaccion.enum';
import { ITipoPagoData } from '@core/interfaces/entidades/tipoPago.entidad';
import { IOptionsSelect } from '@core/interfaces/options.select.interface';
import { ICrearTipoPagoReq } from '@core/interfaces/request-response/tipoPago.dto.interface';
import { TipoPagoApiService } from '@core/services/api/tipo-pago-api.service';
import { ToastService } from '@shared/services/toast.service';
import { UiSelect } from '@shared/components/ui';

@Component({
  selector: 'app-crear-tipo-pago',
  imports: [FormField, UiSelect],
  templateUrl: './crear-tipo-pago.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './crear-tipo-pago.css',
})
export class CrearTipoPago implements OnInit {
  ngOnInit(): void {
    this.tipo_transaccion = Object.values(ETipoTransaccion);
    this.opcionesTipoTransaccion.set(
      this.tipo_transaccion.map((tipo) => ({
        label: tipo,
        value: tipo,
      })),
    );
  }
  // servicios
  private toastService = inject(ToastService);
  private tipoPagoApiService = inject(TipoPagoApiService);
  // datos
  tipo_transaccion: ETipoTransaccion[] = [];
  opcionesTipoTransaccion = signal<IOptionsSelect<ETipoTransaccion>[]>([]);
  formTipoPago = form(
    signal({
      nombre: '',
      tipo_transaccion: ETipoTransaccion.EFECTIVO,
    }),
  );
  cerrar = output<ITipoPagoData | undefined>();

  // métodos
  cancelar() {
    this.cerrar.emit(undefined);
  }
  crear($event: Event) {
    $event.preventDefault();
    const formValue = this.formTipoPago().controlValue();
    const dataToSave: ICrearTipoPagoReq = {
      nombre: formValue.nombre,
      tipo_transaccion: formValue.tipo_transaccion,
    };
    this.tipoPagoApiService.crear(dataToSave).subscribe({
      next: (tipoPagoCreado) => {
        this.toastService.show(
          'top-right',
          'success',
          'Tipo Pago',
          'Tipo de pago creado correctamente.',
        );
        this.cerrar.emit(tipoPagoCreado);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Tipo Pago',
          err.error?.message || 'Error al crear el tipo de pago.',
        );
      },
    });
  }
}
